module.exports = __webpack_public_path__ + "static/media/043.bd09186d.jpg";